export default __webpack_public_path__ + "static/media/006.60801798.jpg";